export default __webpack_public_path__ + "static/media/receiptfilled.8ee788ee.svg";